import { createContext } from 'react';

var StepFormContext = /*#__PURE__*/createContext({
  name: undefined,
  registerStepFormField: function registerStepFormField() {},
  unregisterStepFormField: function unregisterStepFormField() {}
});

export { StepFormContext };
